// $(() => $(document).on('change', '#application-dd-categories input[type=checkbox]', function() {
//   if ($('#application-dd-categories input[type=checkbox]').length > 0) {
//     const number_of_items = $(this).parents().eq(2).find(':checkbox:checked').length;
//     return $(this).parents().eq(8).find('.number-of-selected').text(number_of_items + ' Selected');
//   }
// }));

document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("change", (event) => {
    if (event.target && event.target.id === "attachment_file_type") {

      const fileInput = document.getElementById("extra_file");

      if (fileInput) {
        if (event.target.value === "report") {
          fileInput.setAttribute("accept", "application/pdf");
        } else if (event.target.value === "report") {
          fileInput.setAttribute("accept", ".r,application/octet-stream");
        } else {
          fileInput.removeAttribute("accept");
        }
      }
    }
  });
});
